module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('card', [_c('div', {
    staticClass: "card-demo-flex card-demo-content01",
    slot: "content"
  }, [_c('div', {
    staticClass: "vux-1px-l vux-1px-r"
  }, [_c('p', {
    staticClass: "center-portrait"
  }, [_c('img', {
    attrs: {
      "src": _vm.portrait
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-r"
  }, [_c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.coins) + " 钢蹦\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-r"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "center-coin",
    attrs: {
      "alt": "充值"
    },
    on: {
      "click": _vm.regWxPay
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/pay.png")
    }
  })])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-327d6328!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeHead.vue
// module id = 257
// module chunks = 2